// en, de, fr, pt
export default {
  en: {
    //--------------------导航条开始-----------------------
    systemManagement: 'System',
    dashboard: 'Dashboard',
    roles: 'Roles',
    users: 'Users',
    department: 'Department',
    teams: 'Teams',
    team: 'Team',
    configurations: 'Configurations',

    business: 'Business',
    consumers: 'Consumers',
    consumer: 'Consumer',
    selectCompany: 'Select Company',
    providers: 'Providers',
    provider: 'Provider',

    projectManagement: 'Project',
    projects: 'Projects',
    projectSet: 'Project Setting',
    purchaseOrders: 'Purchase Orders',
    contracts: 'Contracts',
    projectGraph: 'Project Graph',

    orderNumber: 'Number',
    assetsManagement: 'Assets',
    assets: 'Assets',
    zone: 'Zone',
    hardware: 'Hardware',
    software: 'Software',
    carrier: 'Carrier',
    zone_type: 'Zone｜Type',
    createdOn: 'Created On',
    updatedOn: 'Updated On',
    documents: 'Documents',
    document: 'Document Management',

    visitorsManage: 'Visitors',
    visitorsRequest: 'Visitors Request',
    verifyVisitors: 'Verify Visitors',

    ticketSystem: 'Tickets',
    helpdesk: 'Helpdesk',
    tTitle:'Title',
    filter:'Filter',
    stage:'Stage',
    id:'ID',
    ticketSupport: 'Ticket Support',
    standardType:'Standard Type',
    newType:'New Type',
    assetType:'Asset Type',
    solved:'Solved',

    monitorSystem:'monitor',
    monitor:'Monitor',
    //--------------------导航条结束-----------------------

    // -------------------------- department页开始 ------------------------------
    addDepartment: 'Add Department',
    editDepartment: 'Edit Department',
    addDepartMemberTip:'The user is now in another department. Do you want to transfer this user to the current operation department?',
    // -------------------------- department页面结束 ------------------------------

    // -------------------------- 组页面开始 ------------------------------
    members: 'Members',
    member: 'Member',
    addTeam: 'Add Team',
    editTeam: 'edit Team',
    name: 'Name',
    edit: 'Edit',
    addTeam:'Add Team',
    editTeam:'Edit Team',
    // -------------------------- 组页面结束 ------------------------------

    // -------------------------- 用户页面开始 ------------------------------
    add: 'Add',
    usermanager: 'Users Management',
    save: 'Save',
    deleteUser: 'Delete User',
    delete: 'Delete',
    adduser: 'Add User',
    user: 'User',    
    edituser: 'Edit User',
    reviewuser:'Review User',
    passed:'Approve',
    trust:'Trust',
    internal:'Internal',
    external:'External',
    // -------------------------- 用户页面结束 ------------------------------

    //--------------------用户个人信息开始-----------------------
    realname: 'Real Name',
    email: 'Email',
    role: 'Role',
    skills: 'Skills',
    workhistory: 'Work History',
    address: 'Address',
    ranking: 'Ranking',
    update: 'Update',
    idcard: 'Id Card',
    //--------------------用户个人信息结束-----------------------

    // -------------------------- 角色页面开始 ------------------------------
    rolemanager: 'Roles Manager',
    rolename: 'Roles Name',
    status: 'Status',
    read: 'Read',
    insert: 'Insert',
    addrole:'Add Role',
    editRole:'Edit Role',
    // -------------------------- 角色页面结束 ------------------------------

    // -------------------------- 配置页面开始 ------------------------------
    tip: 'Please type a text and press "enter" in order to add multiple values.',
    djnumber: 'Warranty Expiry Alert',
    zschip: 'License Type',
    jfchip: 'IDC Access Reason',
    sjlychip: 'Event Origin',
    sjlx: 'Event Type',
    fbchip: 'Release Management: Test Status',
    // -------------------------- 配置页面结束 ------------------------------

    // -------------------------- 公司信息开始 business------------------------------
    companyinfo: 'Company Info',
    companyname: 'Company Name',
    license: 'License',
    type: 'Type',
    phone: 'Phone',
    map: 'Map',
    province: 'Province',
    city: 'City',
    district: 'District',
    detailAddress: 'Detail Address',
    companyPhone: 'Company Phone',
    contactMobile: 'Contact Person Mobile',
    // -------------------------- 公司信息结束 business------------------------------
    // -------------------------- business module start ------------------------------
    company: 'Company',
    contactPerson: 'Contact Person',
    contactPersonName: 'Contact Person',
    contactPersonPhone: 'Contact Phone',
    concretePosition: 'concrete Position',
    AssignHandler: 'Assign Handler',
    standardText:"standard",
    textNull: 'Is empty or neither is empty',
    unfold: 'unfold',
    packUp: 'packUp',
    rate: 'Rate',
    addConsumer: 'Add Consumer',
    addProvider: 'Add Provider',
    editConsumer: 'Edit Consumer',
    editProvider: 'Edit Provider',
    selectTeam: 'select Team',
    selectCompany: 'select Company',
    // -------------------------- business module end ------------------------------


    // -------------------------- 硬件资产页面开始 ------------------------------
    import: 'Import',
    clickToImport: 'Click to Import',
    export: 'Export',
    generateQR: 'Generate QR',
    owner: 'Owner',
    supervisor: 'Supervisor',
    brand: 'Brand',
    model: 'Model',
    warranty: 'Warranty',
    container: 'Container',
    event: 'Event',
    sn: 'SN',
    size: 'Size',
    code: 'Asset Code',
    power:'Power',
    poweredOn: 'Powered On',
    poweredOff: 'Powered Off',
    unplug: 'Unplug',
    units: "'U' size",
    placeAtU: "Placed At'U'",
    note: 'Note',
    summary:'Summary',
    inspectionNotes: 'Inspection Notes ',
    desc: 'Description',
    project: 'Project',
    system: 'System',
    contract: 'Contract',
    installedOn: 'Installed',
    purchasedOn: 'Purchased',
    maintenancestart: 'Maintenance Start',
    maintenanceend: 'Maintenance End',
    generalinfo: 'General Information',
    ipaddress: 'IP Address',
    attributes: 'Attributes',
    components: 'Components',
    image: 'Image',
    cancel: 'Cancel',
    uploadpic: 'Upload Image',
    upload: 'Upload',
    download: 'Download',
    date: 'Date',
    assetInfo: 'Asset Information',
    projectName: 'Project Name',
    projectGroup: 'Project Group',
    print: 'Print',
    readAsset: 'Read Hardware',
    editAsset: 'Edit Hardware',
    addAsset: 'Add Hardware',
    serialnumber: 'SN#',
    install: 'Install',
    done: 'Done',
    assetHandr:'Asset handling',
    operating:'Operating',
    lifecycle:'Life cycle',
    others:'Others',
    all:'All',
    morechoices:'More Choices',
    rename:'Rename',
    qty:'Qty',
    qrcode:'QR Code',
    imageLimit:'Upload only three pictures',
    previewhardware:'Preview Hardware',
    downloadTemplate:'Download Template',
    leastOwnerTip:'Please specify the owner first',
    changelog:'Change Log',
    fillTips:'Please fill in the input box with * symbol',
    fillTip:'Please enter required fields',
    move: 'Move',
    assertMove: 'Asserts Move',
    // -------------------------- 硬件资产页面结束 ------------------------------


    // -------------------------- 软件资产页面开始 ------------------------------
    version: 'Version',
    architecture: 'Architecture',
    language: 'Language',
    carrierList: 'Carrier List',
    alltype: 'All Type',
    allArch:'All Arc',
    allLang:'All Language',
    operatingsystem: 'Operating System',
    database: 'Database',
    antivirus: 'Anti-virus',
    firewall: 'Fire Wall',
    middleware: 'Middle Ware',
    application: 'Application',
    OS: 'Operating System',
    DATA_BASE: 'Database',
    ANTI_VIRUS: 'Anti-virus',
    FIRE_WALL: 'Fire Wall',
    MIDDLE_WARE: 'Middle Ware',
    APPLICATION: 'Application',
    addsoftware: 'Add Software',
    editsoftware: 'Edit Software',

    licensekey: 'License Key',
    perpetual: 'Perpetual',
    licensetype: 'License Type',
    userlimit: 'User Limit',
    startdate: 'Start Date',
    enddate: 'End Date',
    yes: 'Yes',
    no: 'No',
    // -------------------------- 软件资产页面结束 ------------------------------

    // -------------------------- zone 区域 开始 ------------------------------
    addZone: 'Add Zone',
    editZone: 'Edit Zone',

    // -------------------------- zone 区域 结束 ------------------------------
    // -------------------------- type 区域 开始 ------------------------------
    addType: 'Add Type',
    editType: 'Edit Type',

    // -------------------------- type 区域 结束 ------------------------------

    // -------------------------- 个人信息功能菜单选项开始 ------------------------------
    profile: 'Profile',
    switchcompany: 'Switch Company',
    changepassword: 'Change Password',
    logout: 'Logout',
    applycomapny: 'Apply Company',
    applyInstruction: 'Please enter the company name',
    companyInfo: 'Company Info',
    // -------------------------- 个人信息功能菜单选项结束 ------------------------------
    // -------------------------- 登陆模块开始 ------------------------------
    login: 'Login',
    username: 'Username',
    password: 'Password',
    register: 'Register',
    forgetPwd: 'Forget Password',
    welBack: 'Welcome back, please login to your account.',
    back: 'Back',
    reset: 'Reset',

    createAcc: 'Create Account',
    regInstruction: 'Fill the below form to create a new account.',
    person: 'Person',
    resCompany: 'Company',
    mobile: 'Mobile',
    imageStr: 'Image String',
    shortCode: 'Short Code',
    confirmPwd: 'Confirm Password',
    sendCode: 'Send Code',

    resInstruction: 'Reset password',
    backToLogin: 'Back to Login',
    recoverPwd: 'Recover Password',
    // -------------------------- 登陆模块结束 ------------------------------
    // -------------------------- 组件 修改 开始 ------------------------------
    deleteText: 'Do you want to delete it ?',
    updateText: 'Do you want to update it ?',
    acceptText: 'Delete',
    cancleText: 'Cancel',
    title: 'Confirm',

    // -------------------------- 组件 修改 结束 ------------------------------

    //tooltip
    clicktoview:'Click To View',
    departLeader:'Department Leader',
    teamLeader:'Team Leader',
    clickAsLeader:'Click to set as a Leader',
    passwordVali:'Please provide an alphanumeric password, the length should be between 6 and 20',
    mobileVali:'mobile must be an 11-digit mobile number',
    idNumberVali:'Please enter a Valid ID Number',

    // License Module
    organization: 'Organization',
    UserLimit: 'User Limit',
    Perpetual: 'Perpetual',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    licenceKey: 'Licence Key',
    submit:'Submit',
    // License Module

    // Ticket Module
    new:'New',
    submitted:'Submitted',
    unsubmitted:'Unsubmitted',
    drafts:'Drafts',
    applied:'Applied',
    assigned:'Assigned',
    processing:'Processing',
    analysis:'Analysis',
    analyzed:'Analyzed',
    closed:'Closed',
    applyAc:'Apply an Account',
    info:' Information',
    ticket:'Ticket',
    tTopic:'Ticket Topic',
    paPerson:'Party A contact person',
    partA:'Party A',
    partB:'Party B',
    tOrigin:'Ticket Origin',
    priority:'Priority',
    severty:'Severity',
    reporter:'Reporter',
    assignee:'Assignee',
    rHardware:'Related Hardwares',
    rTicket:'Related Tickets',
    cTicket:'Create Ticket',
    uTicket:'Update Ticket',
    sTicket:'Submit Ticket',
    attachment:'Attachment',
    cause:'Event Cause',
    sln:'Solution',
    mNote:"Please type a text and press 'enter' in order to add multiple values",
    rFile:'Upload Files',
    ticketDetails:'Ticket Details',
    ticketExamine: 'Ticket Examine',
    comments:'Comments',
    // Ticket Module

    submit: 'Submit',
    remarks: 'Remarks',
    process: 'Process',
    return: 'Return',
    assignTo:'Assign to',
    assign:'Assign',
    noHardwares:'no Hardwares',
    noAttachment:'no Attachment',
    plsCrtEv:'Please Create an event',
    plsCrtAc:'Please Create an account',
    fixed:'Fixed',
    to:'To',
    from:'From',
    // License Module

    // Ticket Module
    typeEdit:'Type Edit',
    tInfo:'Type Information',
    tName:'Type Name',
    admin:'Administrator',
    authUser:'Authorized User',
    workingGroup:'Working Group',
    ticketConfiguration:'Ticket Configuration',
    superviser:'Superviser',
    typeManagement:'Type Management',
    modelManagement:'Model Management',
    sTeam:'Support Team',
    close:'Close',
    ticketOverview:'Ticket Overview',
    tOverview:'Ticket Overview',
    overview:'Overview',
    apply:'Apply',
    trend:'Trend',
    priorityDistribution:'Priority Distribution',
    typeGroupDistribution:'Type Group Distribution',
    statistics:'Statistics',
    

    // Landing Page
    lpTitle:`IT Operations Management`,
    lpDesc:`IT Operations Management provides high end smart system to manage Distributed Data Centers,
    Assets and Infrastructure Project management`,
    lpBnrBtn:`Get Started Now`,
    lpserviceTitle1:`Asset Management`,
    lpserviceTitle2:`ITIL`,
    lpserviceTitle3:`SOA`,
    lpserviceDesc1:`The system supports management of software and hardware resources for cloud platforms, physical / virtual servers, storage devices, and application systems. Supports life-cycle process management of assets.`,
    lpserviceDesc2:`The system has built-in process scenarios that conform to the asset fault maintenance business, including event tickets, supports custom process adjustments based on actual maintenance needs.`,
    lpserviceDesc3:`Service-oriented architecture (SOA) is a component model that separates different functional units (called services) of an application and connects them through well-defined interfaces and protocols between these services.`,
    lpFooter:`Copyright © 2016 Shenzhen Hongpusen Technology Co., Ltd. All rights reserved. 粤 ICP 备 15067157 号`,
    // Landing Page

    cLead:'Choose Leader',
    properties:`Properties`,
    propertie:`Basic Information Configuration`,
    projectFile: 'Project Document Configuration',
    ServiceRequest:`Service Request`,
    DIHardware:`Device in hardware`,
    rSpace:`Rack Space`,
    search:`Search`,
    todo:`Todo`,
    tbAssigned:`To be Assigned`,
    pending:`Pending`,
    pendingReview:`Pending Review`,
    assetOverview:`Asset Overview`,
    azDistribution:`Asset Zone Distribution`,
    ttWeek:`Ticket Trend of the Week`,
    newElem:'New Element',
    myCompanies:'My Companies',
    services:'Services',
    memberships:'Memberships',
    membershipRequests:'Membership Requests',
    applyMembership:'Apply Membership',
    companyCode: 'Company Code',
    switch:'Switch',
    quit:'Quit',
    // messages
    deleteMsg: "Deleted Successfully",
    duplicateMsg: "Data already exist",
    addMsg: "Inserted Successfully",
    updateMsg: "Updated Successfully",
    loginMsg: "Login Successfully!",
    CodeSendMsg: "Message Sent Successfully",
    registerMsg: "Registered Successfully!",
    dptMsg: "The department level is not more than 5",
    primary:'Primary',
    makePrimary:'Click to make Primary',
    backServices:'Back to Services',
    backDashboard:'Back to Dashboard',
    pageNotFound:'Page Not Found',
    idNumber:'ID Number',
    underApprovel:'New user waiting for Approvel',
    invalidAuth:'Invalid Username Or Password',
    userExists:'User already exists',
    poweredOnTip: 'Powered components cannot be moved',
    pendingReviewTip:'Pending Review',
    approvedUser:'Approved User',
    outofcontainer:'Out of container',
    myProfile: 'My Profile',
    companyProfile: 'Company Profile',
    paPersonInfo: 'Name / Phone',
    inspectionBy: 'Inspection Cycle',
    inspectionMethod: 'Inspection Method',
    available:'Available',
    warehouse:'Warehouse',
    discarded:'Discarded',
    maintenance:'Maintenance',
    AVAILABLE:'Available',
    WAREHOUSE:'Warehouse',
    DISCARDED:'Discarded',
    MAINTENANCE:'Maintenance',
    notAvailable:'not available',
    low:'Low',
    medium:'Medium',
    high:'High',
    veryHigh:'Very High',
    critical:'Critical',
    plow:'Low Priority',
    pmedium:'Medium Priority',
    pvhigh:'Very High Priority',
    phigh:'High Priority',
    selow:'Low Severity',
    semedium:'Medium Severity',
    sehigh:'Critical Severity',
    createNew:'Create New',
    standardrequest:'Standard Tickets',
    assetrequest:'Asset Access Tickets',
    inspectionrequest:'Inspection Tickets',
    discardrequest:'Discard Request',
    newTicket:'New Ticket',
    assetCode:'Asset Code',
    listOfSns:'List of SN',
    standard:'Standard',
    eTicket:'Event Ticket',
    Warehousing:'Warehouse',
    request:'Request',
    malfunction:'Malfunction',
    troubleshoot: 'Malfunction',
    assetControlManagement:'Asset Control Management',
    warehouse:'Warehouse',
    requestHardware:'Request Hardware',
    returnHardware:'Return Hardware',
    inspection:'Task',
    scrap:'Scrap',
    assetDiscardManagement:'Asset Discard Management',
    assetSupportTitle:'Asset Access Tickets ( Warehouse , Request Hardware, Return Hardware )',
    standardSupportTitle:'Standard Requests ( Event , Services , Troubleshoot ) ',
    standardTickets:'Standard Tickets',
    group:'Group',
    assignable:'Assignable',
    send:'Send',
    // messages

    // no data
    nodata:'No data Available',
    label:'Label',
    value:'Value',
    settings:'Settings',
    accessType:'Access Type',


    // tooltips
    eventDesc:`For emergencies in the user's business process, you can apply for support from the provider.`,
    requestDesc:'You can apply for new resources and services from your provider.',
    malfunctionDesc:'Troubleshoot support requests from your provider. It might be caused by device failure or malfunction.',
    warehouseDesc:'You can apply for a warehouse record entry to store new asset entries. The Assets which are not currently in the system record.',
    requestHardwareDesc:'Hardware / Asset requisition request.',
    returnHardwareDesc:'Hardware / Asset return request.',
    inspectionDesc:'Hardware / Asset inspection task ticket, it will log your access to the assets for inspection purpose.',
    discardRequestDesc:'The analysis and review request for hardware discard, if the hardware is completely damaged or not workable anymore then you can request for discard analysis.',
    addDepartMember:'you do not have enough permission, please contact to your administrator',
    inuse:'This role is being used',
    repeat:'Repeat',
    operPlgin:'Please select at least one  first',
    // tooltips
    responsibility:'Responsibility',
    tickets:'Tickets',
    changedThe:'Changed the',
    none:'None',
    recievedTickets:'Recieved Tickets',
    sentTickets:'Sent Tickets',
    inProgress:'In Progress',
    approved:'Approved',
    rejected:'Rejected',
    REJECTED:'Rejected',
    done:'Done',
    manager:'Manager',
    currentCompanyError:'One of these companies must be your current company',
    daily:'Daily',
    weekly:'Weekly',
    monthly:'Monthly',
    on:'on',
    reviewer:'Reviewer',
    review:'Review',
    supportTickets:'Support Tickets',
    assetControlTickets:'Asset Control Tickets',
    activities:'Activities',
    member:'Member',
    manager:'Manager',
    administrator:'Administrator',
    trustExplain:"Trust refers to the user's level, from high to low are owner, admin, internal, external. Only owner and admin can add or edit users. Users cannot operate users higher than their own level. ",
    // tips
    check:'Please check the ',
    row:' Row ',
    required:' is required',
    maturity:'Warranty date expires',
    Expiring:'Maintenance date is about to expire',
    createdBy:'Created By',
    assignMe:'Assign me',
    images:'Images',
    notAllowed:"You don't have access to modify",
    closed:"Closed",
    assignedMe:"Assigned to me",
    notAdd:"The user has been added",

    //overview
    server:'Server',
    storge:'Storge',
    cabinet:'Cabinet',
    storage:'Storage',
    router:'Router',
    other:'Others',
    hardwareType:'Hardware type statistics',
    hardwareStatus:'Hardware status',
    softwareType:'Software type statistics',
    AssetGrowth:'Asset growth trend',
    hardwarePower:'Hardware power status',
    assetStatis:'Asset statistics',

    Blocked: 'Blocked',
    TODO: "Pending",
    TO_DO:"Todo",
    IN_PROGRESS:"In Progress",
    in_progress:"In Progress",
    IN_REVIEW:"In Review",
    APPROVED:"Approved",
    NOT_APPROVED:"Not Approved",
    DONE:'Done',
    CLOSED:'Closed',
    performance:'Performance',

    // monitor system
    hostMonitoring:'Host monitoring',
    host:'Host',
    alarm:'Alarm',
    remind:'Remind',
    ram:'RAM',
    equipmentStatus:'Equipment Status',

    // monitor
    objectName:'Object name',
    monitorType:'Type of monitoring',
    enableMonitore:'Enable monitoring',
    monitorMode:'Monitor mode',
    deviceName:'Device Name',
    deviceType:'Device Type',
    parentNode:'Parent Node',
    monitorDetail:'Monitor Detail',
    basicOverview:'Basic overview',
    indexList:'Index list',
    assetDetail:'Asset Details',
    addMontitor:'Add Monitor',
    monitorStatus:'Monitoring status',
    monitorEnable:'Monitoring enabled',
    runtime:'Running Time',
    disk:'Disk',
    indexName:'Index Name',
    indexType:'Index Type',
    interval:'Interval',
    latestValue:'Latest value',
    time:'Time',
    utilRate:'Utilization rate',
    indexInfo:'Index Info',
    index:'Index',
    CPUper:'CPU percentage occupied by user space',
    uptodate:'Up To Date',
    min:'Minimal',
    average:'Average',
    max:'Maximum',
    oneHour:'One Hour',
    oneDay:'One Day',
    oneWeek:'One Week',
    oneMonth:'One Month',
    //
    STANDARD_EVENT:'Event Ticket',
    STANDARD_REQUEST:'Services Ticket',
    STANDARD_TROUBLESHOOT:'Troubleshoot Request',
    ASSET_WAREHOUSE:'Warehouse Ticket',
    ASSET_USE_REQUEST:'Request Hardware',
    ASSET_RETURN:'Return Hardware',
    ASSET_INSPECTION:'Inspection Ticket',
    ASSET_DISCARD:'Scrap Request',
    support:'Support',
    working:'Working',
    not_working:'Not Working',
    markAs:'Mark As',
    reporterfeedback:'Reporter Feedback',

    // performance
    lastWeek:'Last Week',
    lastMonth:'Last Month',
    lastYear:'Last Year',
    assignTicket:'Assigned ticket',
    solveTicket:'Solve ticket',
    priorityTicket:'Priority of Solved Tickets',
    assignedTicket:'Assigned Tickets',
    create:'Create',
    alarmContent:'Alarm Content',
    preview:'Preview',
    assetField:'Asset Fields',
    inspectionIndex:'Hardware Inspection Points',
    inspectionPoints:'Inspection Points',
    inspectionPointsWindow: 'Inspection Points',
    assetInspection:'Inspection',
    template:'Templates',
    schedule:'Plan',
    maintainenceDate:'Maintainence Date',
    inspector:'Inspector',
    normal:'Normal',
    abnormal:'Abnormal',
    addPoint:'Add Point',
    ok:'Ok',
    result:'Result',
    frequency:'Frequency',
    enable:'Enable',
    typeSNToSearchHardware:'Type Name to search Hardware',
    taskCompleteWarning:'Please review your task carefully, Once you finish the task it will be locked and readonly (cannot edit)',
    finish:'Finish',
    points: 'Points',
    deadline: 'Deadline',
    hardwareDetails: 'Hardware Details',
    allFieldsRequired: 'Please fill the data in all Rrquired fields',
    progress: 'Progress',
    reference: 'Reference',
    enabled: 'Enabled',
    disabled: 'Disabled',
    inspectionReports: 'Inspection Reports',
    reports: 'Reports',
    kpi: 'KPI',
    kpiAbbr: 'Key Performance Indicator',
    startDate: 'Start Date',
    buttonProject: 'View Project Details',
    OperationstartDate: 'Operation Start Date',
    OperationEndDate: 'Operation End Date',
    endDate: 'End Date',
    customer: 'Customer',
    contractNumber: 'Contract Number',
    projectManager: 'Project Manager',
    customerManager:'Customer Manager',
    Aname:"Name of Party A's Company",
    governmentProject: 'Government Project',
    itProject: 'IT Project',
    milestone: 'Milestone',
    issues: 'Issues',
    projectDetail:'Project Detail',
    task:'Task',
    Classic: 'List',
    board: 'Board',
    creator:'Creator',
    basicInfo:'Basic Info',
    conductor :'Conductor ',
    creater: 'Creater',
    attachments:'Attachments',
    predecessors:'Predecessor Task',
    deliverable:'Deliverable',
    deliveryPlan:'Delivery Plan',
    missionDetails:'Mission Details',
    instructions:'Instructions',
    ACTIVE:'Active',
    DELETED:'Deleted',
    duration:'Duration',
    day:'Days',
    tabular:'Tabular',
    graphical:'Graphical',
    parentTask:'Parent Task',
    bug:'Bug',
    mainMenu:'Main Menu',
    taskDetail:'Plan Detail',
    hardwareDetail:'Hardware Detail',
    templateDetail:'Template Detail',
    createProject:'Create Project',
    mask:'Mask',
    purchasedOnDate:'Purchased On',
    mobileNumberNotFound:'Mobile Number not Found',
    viewHardware:'View Hardware',
    InspectionReports:'Inspection Reports',
    InspectionReport:'Inspection Report',
    inspectionTask:'Inspection Task',
    extranetRoom: 'External Room',
    PrivateRoom: 'Private Room',
    hostingRoom: 'Hosting Room',
    assetImport: 'Import Asset',
    loadMore:'Load More',
    of:'of',
    finished:'are Finished',
    taskSavedMsg:'Task Data Saved',
    saveTaskTooltip:'Save Task Data For later use',
    workContent:'Work Content',
    workLog:'Work Log',
    checkList:'Check List',
    similarNameWarning:'File Name should be same as mentioned in checklist',
    fileName:'File Name',
    projectAssets: 'assets',
    addSystem: 'Add System',

    taskWarning:'Task not completed，Please review your task carefully',
    reportUpload: 'Report Upload',
    inspectionCalendar: 'Inspection Calendar',
    exceptionInformation: 'Exception Information',
    exceptionReport: 'Exception Report',
    more: 'More',
    todayInspection: "Today's Inspection",
    statisticsWeek: "Statistics week",
    inspectionsWeek: "本周巡检情况",
    abnormalWeek: "Abnormal this week",
    weekView: 'Week View',
    monthView: 'Month View',
    inspectorTitle: 'inspector',
    keyword: 'Please enter keywords to search',
    allInspector: 'All Inspector',
    lastWeek: 'Last Week',
    nextWeek: 'Next Week',
    myInspection: 'My Inspection',
    inspectionName: 'Inspection Name',
    chooseFile: 'Choose File',
    filesName: 'File Name',
    uploader: 'Uploader',
    placeInfo: 'Place Information',
    projectContracts: 'Project Contract',
    contractAmount: 'Contract Amount',
    contractName: 'Contract Name',
    contractCode: 'Contract Code',
    projectMember: 'Project Members',
    ProjectStakeholders: 'Project stakeholders',
    projectMembers: 'Project Members',
    Workinformation: 'Work Order Information',
    ticketInformation: 'Work Order Information',
    workprocessed: "Your work order has been processed",
    createdprocessed: "Your work order has been created",
    workingprocessed: 'Ticket proceed',
    ticketINVALID: 'Ticket invalid',
    reviewprocessed: 'Ticket review',
    knowledge: 'Knowledge',
    detail: 'Details',
    sphereInfluence:'Ophere of influence',
    resultHandling: 'Result of handling',
    ticketRedeploy: 'Ticket Redeploy',
    submitAudit: 'Submit Audit',
    doneAndClosed: 'Done and closed',
    closetoconfirm: 'Close to confirm',
    closetoconfirmText: 'Please confirm that your work order has been processed. It cannot be returned for modification after confirmation',
    passTheAudit :'Pass the audit',
    reviewTheReturn: 'Review the return',
    processRecord: 'Process record',
    handlingTime: 'Handling time',
    hae: 'Hardware already exists',
    moreFive: 'A maximum of five items can be added',
    taskNoEdit: 'Inspection plans are disabled and cannot be edited',
    parameters: ' Parameter',
    dateWarning: 'Warranty Date Warning',
    outDate: 'Out of date',
    projectType: 'Project Type',
    defaultFiles: 'Default file location',
    folderJd: 'Directory Permission Configuration',
    setManager: 'Set as manager',
    delManager: 'Delete manager',
    jurisdiction: 'Jurisdiction',
    docs: 'Docs',
    docsName: 'Docs Name',
    newuser: 'New Name',
    enterName: 'Please enter a file name',
    nodel: 'Contains subdirectories cannot be deleted',
    slectFolder: 'Please select folder',
    defNoDel: 'The default directory cannot be operated',
    userRight: 'user right',
    visibleUser: 'Visible to the user',
    addFolder: 'Add Folder',
    editFolder: 'Edit Folder',
    documentTitle: 'Document title',
    finalVersion: 'Final version',
    markFV: 'Mark final version',
    cancelFV: 'Cancel final version',
    searchResult: 'Search result',
    notAddName: 'Name already exists',
    notDelProject: 'The item type is already in use and cannot be deleted',
    havaFileNotDel: 'There are files in the directory and cannot be deleted',
    onlyNumber: 'You can only enter numbers',
    maxFileUploader: 'A maximum of 100 MB can be uploaded',
    alls: 'All',
    ticketPersonal: 'Personal Space',
    ticketRanked: 'Ranking List',
    haveRoleName: 'The role name already exists',
    projecInfo: 'Project Info',
    createUser: 'Create User',
    transfer: 'Transfer',
    transferCompany: 'Transfer of company owner',
    currentOwner: 'Current owner',
    verification: 'The verification code is incorrect',
    transferring: 'Transferring object Users',
    ticketNum: 'Ticket Number',
    resolutionRate: 'Resolution Rate',
    wtd: 'Waiting for ticket distribution',
    projectTicketStatistics: 'Project work order statistics',
    ticketStatistics: 'Ticket Statistics',
    ticketDistribution: 'Ticket Distribution',
    oneMonth: 'One Month',
    threeMonth: 'Three Month',
    noTicket: 'No Ticket',
    completedToday: 'Completed today',
    allTicket: 'All Ticket',
    waitToDo: 'Wait for me to deal with it',
    myCreate: 'My Create',
    todoTime: 'The processing time',
    waitMeToDo: 'My to-do list',
    myCompletionRate: 'My completion rate',
    myTicketNum: 'Ticket Number',
    todoTicket: 'Total number of work orders processed',
    closeTickets: 'Complete the number',
    creatTickets: 'Created Tickets',
    notCloseTicket: 'Tickets not close',
    avgTime: 'Average processing time',
    cumulativeTime: 'Cumulative processing time',
    myTicketDis: 'My tickets distribution',
    personTicketRanked: 'Person Ranking List',
    rankings: 'ranking',
    closeT: 'Complete the number',
    completionRate: 'Completion rate',
    projectRanked: 'Project Ranking List',
    entrants: 'Entrants',
    ontheproject: 'On the project',
    toproject: 'Project',
    tuimc: 'transfer users in multiple companys',
    tdlt3d: 'transfer date less than 30 days',
    userOwnerTip: 'Confirm to transfer the company owner to user John, the company owner cannot be transferred again for 30 days after this transfer  ',
    editNewPassword: 'Please enter your new password.',
    newPassword: 'New Password',
    hardwareTrend: 'Asset growth',
    softwareTrend: 'Software growth',
    count: 'Assets',
    switchs: 'Switchs',
    harsoftware: 'Software',
    overInsurance: 'Has been confirmed',
    soonInsurance: 'Soon Insurance',
    assetStates: 'Asset States',
    projectAssetstus: 'Project Assets Overview',
    zoneAssetstus: 'Zone Assets Overview',
    assetexpired: 'Asset Expired',
    directoryDescription: 'Directory description',
    ticketObsolete: 'Ticket Obsolete',
    INVALID: 'Invalid',
    isInvalidTicket: 'Whether the invalid',
    toticketDetails: 'to Ticket for details'
  },

  zh: {
    //--------------------导航条开始-----------------------
    systemManagement: '系统管理',
    dashboard: '面板',
    roles: '角色',
    users: '用户',
    department: '部门',
    teams: '组',
    team: '球队',
    configurations: '配置',

    business: '商务',
    consumers: '客户',
    consumer: '客户',
    selectCompany: '选择公司',
    providers: '供应商',
    provider: '供应商',

    projectManagement: '项目管理',
    projects: '项目',
    projectSet: '项目配置',
    projectDoc: '文档库',
    purchaseOrders: '采购清单',
    contracts: '合同',
    projectGraph: '工程图表',

    orderNumber: '序号',
    assetsManagement: '资产管理',
    assets: '资产',
    zone: '区域',
    hardware: '硬件',
    software: '软件',
    carrier: '载体',
    zone_type: '区域与类型',
    createdOn: '创建时间',
    updatedOn: '更新日期',
    documents: '文件',
    document: '文档管理',


    visitorsManage: '访客管理',
    visitorsRequest: '访问请求',
    verifyVisitors: '访客审核',

    ticketSystem: '工单系统',
    applyTicket: '新建工单',
    ticketSupport: '服务工单',

    monitorSystem:'监控系统',
    monitor:'监控',
    //--------------------导航条结束-----------------------

    // -------------------------- department页开始 ------------------------------
    addDepartment: '添加部门',
    editDepartment: '编辑部门',
    addDepartMemberTip:'该用户现在在其他部门，请问要将此用户转移至当前操作部门吗？',
    // -------------------------- department页面结束 ------------------------------

    // -------------------------- 组页面开始 ------------------------------
    members: '成员',
    member: '成员',
    addTeam: '添加 组',
    editTeam: '编辑 组',
    name: '名称',
    edit: '编辑',
    addTeam:'添加组',
    editTeam:'编辑组',
    // -------------------------- 组页面结束 ------------------------------

    // -------------------------- 用户页面开始 ------------------------------
    add: '添加',
    usermanager: '用户管理',
    save: '保存',
    deleteUser: '删除 用户',
    delete: '删除',
    user: '用户',
    adduser: '添加用户',
    edituser: '编辑用户',
    reviewuser:'审核用户',
    passed:'通过',
    trust:'级别',
    internal:'内部',
    external:'外部',
    underApprovel:'新用户等待批准',
    // -------------------------- 用户页面结束 ------------------------------

    //--------------------用户个人信息开始-----------------------
    realname: '姓名',
    email: '邮箱',
    role: '角色',
    skills: '技能',
    workhistory: '工作经历',
    address: '地址',
    ranking: '用户评价',
    update: '更新',
    idcard: '身份证',
    //--------------------用户个人信息结束-----------------------

    // -------------------------- 角色页面开始 ------------------------------
    rolemanager: '角色管理',
    rolename: '角色名称',
    status: '状态',
    read: '查看',
    insert: '新增',
    addrole:'添加角色',
    editRole:'编辑角色',
    // -------------------------- 角色页面结束 ------------------------------

    // -------------------------- 配置页面开始 ------------------------------
    tip: '请输入文字并且按Enter键添加多个数值',
    djnumber: '单据过期预警',
    zschip: '证书类型',
    jfchip: '机房出入原因',
    sjlychip: '事件来源',
    sjlx: '事件类型',
    fbchip: '发布管理：检测状态',
    // -------------------------- 配置页面结束 ------------------------------

    // -------------------------- 公司信息开始 business ------------------------------
    companyinfo: '公司信息',
    myProfile: '个人信息',
    companyProfile: '公司简介',
    
    companyname: '公司名称',
    license: '证书',
    type: '类型',
    phone: '电话',
    map: '地图',
    province: '省',
    city: '市',
    district: '区',
    detailAddress: '详细地址',
    selectTeam: '选择组别',
    selectCompany: '选择公司',
    companyPhone: '公司电话',
    contactMobile: '联系人手机',
    // -------------------------- 公司信息结束 business ------------------------------
    // -------------------------- business module start ------------------------------
    company: '客户名称',
    contactPerson: '联系人',
    contactPersonName: '对接人姓名',
    contactPersonPhone: '对接人电话',
    concretePosition: '具体位置',
    AssignHandler: '指派处理人',
    standardText:"规范",
    textNull: '为空或者均不为空',
    unfold: '展开',
    packUp: '收起',
    rate: '评级',
    addConsumer: '添加客户',
    addProvider: '添加供应商',
    editConsumer: '编辑客户',
    editProvider: '编辑供应商',
    // -------------------------- business module end ------------------------------




    // -------------------------- 硬件资产页面开始 ------------------------------
    import: '导入',
    clickToImport: '点击导入',
    export: '导出',
    generateQR: '二维码',
    owner: '所有者',
    supervisor: '负责人',
    brand: '品牌',
    model: '型号',
    warranty: '到期日期',
    container: '容器',
    event: '事件',
    sn: '序列号',
    size: '大小',
    code: '资产编码',
    power:'上电',
    poweredOn: '上电',
    poweredOff: '下电',
    unplug: '去插件',
    placeAtU: "位置",
    units: 'U 数',
    note: '备注',
    summary:'巡检总结',
    inspectionNotes: '检验注意事项',
    desc: '描述',
    project: '项目',
    system: '系统',
    contract: '合同',
    installedOn: '安装日期',
    purchasedOn: '购买日期',
    maintenancestart: '维保开始时间',
    maintenanceend: '维保结束时间',
    generalinfo: '基本信息',
    date: '日期',
    assetInfo: '资产信息',
    projectName: '项目名称',
    projectGroup: '项目分组',
    ipaddress: 'IP 地址',
    attributes: '属性',
    components: '组件',
    image: '图片',
    cancel: '取消',
    uploadpic: '上传图片',
    upload: '上传',
    download: '下载',
    print: '打印',
    readAsset: '查看硬件',
    editAsset: '编辑硬件',
    addAsset: '添加硬件',
    serialnumber: '序列号',
    install: '安装',
    done: '完成',
    assetHandr:'资产处理',
    operating:'操作',
    lifecycle:'生命周期',
    others:'其他',
    all:'全部',
    morechoices:'更多选择',
    rename:'重命名',
    qty:'数量',
    qrcode:'二维码',
    imageLimit:'仅可上传三张图片',
    previewhardware:'预览硬件',
    downloadTemplate:'下载模版',
    leastOwnerTip:'请先指定所有者',
    changelog:'变更日志',
    fillTips:'请填入带*符号输入框',
    fillTip:'请输入必填项',
    move: '移动',
    assertMove: '资产移动',
    // -------------------------- 硬件资产页面结束 ------------------------------

    // -------------------------- 软件资产页面开始 ------------------------------
    version: '版本',
    architecture: '架构',
    language: '语言',
    carrierList: '载体列表',
    alltype: '所有类型',
    allArch:'所有架构',
    allLang:'所有语言',
    operatingsystem: '操作系统',
    database: '数据库',
    antivirus: '虚拟机',
    firewall: '防火墙',
    middleware: '中间件',
    application: '其他应用',
    OS: '操作系统',
    DATA_BASE: '数据库',
    ANTI_VIRUS: '虚拟机',
    FIRE_WALL: '防火墙',
    MIDDLE_WARE: '中间件',
    APPLICATION: '其他应用',
    addsoftware: '添加软件',
    editsoftware: '编辑软件',

    licensekey: '证书密钥',
    perpetual: '永久的',
    licensetype: '证书类型',
    userlimit: '用户限制',
    startdate: '服务开始日期',
    buttonProject: '查看项目详细信息',
    OperationstartDate: '运维开始时间',
    OperationEndDate: '运维结束时间',
    enddate: '服务结束日期',
    yes: '是',
    no: '否',
    // -------------------------- 软件资产页面结束 ------------------------------

    // -------------------------- zone 区域 开始 ------------------------------
    addZone: '添加区域',
    editZone: '编辑区域',

    // -------------------------- zone 区域 结束 ------------------------------
    // -------------------------- type 区域 开始 ------------------------------
    addType: '添加类型',
    editType: '编辑类型',

    // -------------------------- type 区域 结束 ------------------------------

    // -------------------------- 个人信息功能菜单选项开始 ------------------------------
    profile: '个人信息',
    switchcompany: '切换公司',
    changepassword: '修改密码',
    logout: '退出',
    applycomapny: '申请公司',
    applyInstruction: '请输入公司名称',
    companyInfo: '公司信息',
    // -------------------------- 个人信息功能菜单选项结束 ------------------------------
    // -------------------------- 登陆模块开始 ------------------------------
    login: '登陆',
    username: '用户名',
    password: '密码',
    register: '注册',
    forgetPwd: '忘记 密码',
    welBack: '欢迎回来， 请登录你的账号',
    back: '返回',
    reset: '重置',

    createAcc: '注册账户',
    regInstruction: '填写以下信息注册账户',
    person: '个人',
    resCompany: '公司',
    mobile: '手机',
    imageStr: '图形验证码',
    shortCode: '短信验证码',
    confirmPwd: '确认密码',
    sendCode: '发送验证码',

    resInstruction: '重置密码',
    backToLogin: '返回 登陆',
    recoverPwd: '重置密码',
    // -------------------------- 登陆模块结束 ------------------------------
    // -------------------------- 组件 修改 开始 ------------------------------
    deleteText: '确定删除这项吗?',
    updateText: '您要更新吗？',
    acceptText: '删除',
    cancleText: '取消',
    title: '确认',
    // -------------------------- 组件 修改 结束 ------------------------------

    //tooltip
    clicktoview:'点击查看',
    departLeader:'部门领导',
    teamLeader:'组领导',
    clickAsLeader:'点击设置为领导',
    passwordVali:'请提供字母数字密码，长度应在6到20之间',
    mobileVali:'手机号必须是11位手机号码',
    idNumberVali:'请输入有效的身份证号',
    idNumber:'身份证号码',

    // License Module
    organization: '组织',
    UserLimit: '用户限制',
    Perpetual: '永久',
    StartDate: '开始日期',
    EndDate: '结束日期',
    licenceKey: '许可证密钥',
    submit: '提交',

    // Ticket Module
    new:'新增',
    submitted:'提交',
    unsubmitted:'未提交',
    drafts:'草稿',
    applied:'应用',
    assigned:'分配',
    processing:'处理',
    analysis:'分析',
    analyzed:'分析完成',
    closed:'关闭',
    applyAc:'申请帐户',
    info:'信息',
    ticket:'工单',
    tTopic:'工单标题',
    paPerson:'甲方联系人',
    partA:'甲方',
    partB:'乙方',
    tOrigin:'工单来源',
    priority:'优先级',
    severty:'严重性',
    reporter:'负责人',
    assignee:'受理人',
    rHardware:'相关硬件',
    rTicket:'相关工单',
    cTicket:'创建工单',
    uTicket:'创建工单',
    sTicket:'创建工单',
    attachment:'附件',
    cause:'事件原因',
    sln:'解决 方案',
    mNote:'请键入文本并按"输入"以添加多个值',
    rFile:'上传文件',
    ticketDetails:'工单详情',
    ticketExamine: '工单审批',
    comments:'评论',
    remarks: '备注',
    return: '退回',
    assignTo:'分配给',
    assign:'分配',
    noHardwares:'在硬件中',
    noAttachment:'无附件',
    plsCrtEv:'请创建活动',
    plsCrtAc:'请创建帐户',
    fixed:'固定',
    to:'至',
    from:'从',

    typeEdit:'类型编辑',
    tInfo:'类型信息',
    tName:'类型名称',
    admin:'管理员',
    authUser:'授权用户',
    workingGroup:'工作小组',
    ticketConfiguration:'工单配置',
    superviser:'主管',
    typeManagement:'类型管理',
    modelManagement:'类型管理',
    sTeam:'支持团队',
    close:'关',
    ticketOverview:'总览',
    tOverview:'工单总览',
    overview:'总览',
    apply:'申请',
    helpdesk: '帮助台',
    tTitle:'标题',
    id:'身份',
    filter:'筛选',
    stage:'阶段',
    standardType:'标准类型',
    newType:'新型',
    assetType:'资产类型',
    solved:'已解决',
    trend:'工单趋势',
    priorityDistribution:'工单分布（优先级）',
    typeGroupDistribution:'工单分布（类型）',
    statistics:'统计',
    // Ticket Module

    // Landing Page
    lpTitle:`IT运营管理`,
    lpDesc:`IT运营管理提供高端智能系统来管理分布式数据中心，资产和基础设施项目管理`,
    lpBnrBtn:`开始`,
    lpserviceTitle1:`资产管理`,
    lpserviceTitle2:`ITIL`,
    lpserviceTitle3:`SOA`,
    lpserviceDesc1:`该系统支持对云平台，物理/虚拟服务器，存储设备和应用程序系统的软件和硬件资源的管理。支持资产的生命周期过程管理。`, 
    lpserviceDesc2:`该系统具有符合资产故障维护业务的内置过程方案，包括事件凭单，支持根据实际维护需求进行自定义过程调整。`,
    lpserviceDesc3:`面向服务的体系结构（SOA）是一个组件模型，用于分隔应用程序的不同功能单元（称为服务），并通过这些服务之间定义良好的接口和协议将它们连接起来。`,
    lpFooter:`版权所有 © 2016 深圳市鸿普森科技股份有限公司 版权所有 粤ICP备15067157号`,
    // Landing Page

    cLead:'选择领导者',
    newElem:'新元素',
    properties:`基础信息`,
    propertie: '基础信息配置',
    projectFile: '项目文档配置',
    ServiceRequest:`服务请求`,
    DIHardware:`硬件设备`,
    rSpace:`机架空间`,
    search:`搜索`,
    todo:`资产巡检`,
    tOverview:`工单总览`,
    tbAssigned:`待分配`,
    pending:`待解决`,
    pendingReview:`待审核`,
    assetOverview:`资产总览`,
    azDistribution:`资产区域分布`,
    ttWeek:`本周工单趋势`,
    services:'服务',
    memberships:'公司资格',
    membershipRequests:'公司请求',
    applyMembership:'申请会员',
    companyCode: '公司编号',
    switch:'切换',
    quit:'退出',
    deleteMsg: "删除成功",
    duplicateMsg: "数据已经存在",
    addMsg: "成功插入",
    updateMsg: "更新成功",
    loginMsg: "登录成功!",
    CodeSendMsg:'验证码发送成功',
    shortCodeSendMsg: "登录成功!",
    primary:'默认公司',
    makePrimary:'单击设为默认公司',
    backServices:'返回服务',
    backDashboard:'返回资讯主页',
    pageNotFound:'找不到网页',
    invalidAuth:'无效的用户名或密码',
    userExists:'用户已存在',
    poweredOnTip: '已上电的插件不可移动',
    pendingReviewTip:'待审核新用户',
    approvedUser:'审核通过用户',
    outofcontainer:'放置U位超出容器容纳范围',
    paPersonInfo: '名称 / 电话',
    inspectionBy: '巡检周期',
    inspectionMethod: '巡检方法',
    available:'可用',
    warehouse:'库存',
    discarded:'报废',
    maintenance:'维修',
    AVAILABLE:'可用',
    WAREHOUSE:'库存',
    DISCARDED:'报废',
    MAINTENANCE:'维修',
    notAvailable:'无法使用',
    low:'低',
    medium:'中',
    high:'高',
    veryHigh:'极高',
    critical:'危急',
    plow:'低优先级',
    pmedium:'中优先级',
    pvhigh:'很高的优先级',
    phigh:'高优先级',
    selow:'严重程度低',
    semedium:'中等严重性',
    sehigh:'严重程度',
    createNew:'创建工单',
    standardrequest:'标准工单',
    assetrequest:'资产工单',
    inspectionrequest:'巡检工单',
    discardrequest:'报废工单',
    newTicket:'创建工单',
    assetCode:'资产代码',
    listOfSns:'序列号列表',
    // messages

    // no data
    nodata:'无数据',

    standard:'标准',
    eTicket:'事件',
    Warehousing:'入库',
    request:'请求',
    malfunction:'故障',
    troubleshoot: '故障',
    assetControlManagement:'资产控制管理',
    warehouse:'入库',
    requestHardware:'领用',
    returnHardware:'利旧',
    inspection:'资产巡检',
    scrap:'废料',
    assetDiscardManagement:'废弃',
    standardTickets:'标准工单',
    group:'组',
    assignable:'可分配的',
    label:'名称',
    value:'数值',
    send:'发送',
    settings:'设置',
    accessType:'访问类型',
    eventDesc:`用户业务过程中的突发事件，可以向供应商申请支援。`,
    requestDesc:`用户需要资源或服务，可以向供应商申请支援。`,
    malfunctionDesc:`用户的设备发生故障或其他问题，可以向供应商申请支援。`,
    warehouseDesc:`此类工单用于新硬件资产入库。`,
    requestHardwareDesc:`此类工单用于硬件资产领用。`,
    returnHardwareDesc:`此类工单用于已领用的硬件资产归还。`,
    inspectionDesc:`此类工单用于运维工程师资产巡检。`,
    discardRequestDesc:`此类工单用于硬件资产废弃。`,
    addDepartMember:'您没有足够的权限，请与您的管理员联系',
    inuse:'该角色正在被使用中',
    repeat:'重复',
    operPlgin:'请先选择至少一个进行操作',
    // tooltips
    responsibility:`职责`,
    tickets:'工单',
    changedThe:'改变了',
    none:'没有',
    recievedTickets:'已接收',
    sentTickets:'已发送',
    inProgress:'处理中',
    approved:'已批准',
    rejected:'拒绝',
    REJECTED: '拒绝',
    done:'完成',
    assetSupportTitle:'资产工单',
    standardSupportTitle:'事件工单',
    manager:'经理',
    currentCompanyError:'这些公司之一必须是您当前的公司',
    daily:'每天',
    weekly:'每周',
    monthly:'每月一次',
    on:'于',
    reviewer:'审核人',
    review:'评论',
    supportTickets:'标准工单',
    assetControlTickets:'资产工单',
    activities:'工单动态',
    member:'成员',
    manager:'管理员',
    administrator:'超级管理员',
    trustExplain:'信任是指用户的级别，从高到低依次是所有者，管理员，内部，外部。 只有所有者和管理员可以添加或编辑用户。 用户不能操作高于其自身级别的用户。',
    // tips
    check:'请核查第',
    row:'行',
    required:'为必填',
    maturity:'维保日期到期',
    Expiring:'维保日期即将到期',
    createdBy:'创建者',
    assignMe:'分配我',
    images:'图片',
    notAllowed:"您无权修改",
    closed:"关闭",
    assignedMe:"分配给我",
    notAdd:"此用户已被添加",

    //overview
    server:'服务器',
    storge:'存储',
    cabinet:'机柜',
    storage:'存储',
    router:'路由',
    other:'其他',
    hardwareType:'硬件类型',
    hardwareStatus:'硬件状态',
    softwareType:'软件类型',
    AssetGrowth:'资产增长趋势',
    hardwarePower:'硬件上电状态',
    assetStatis:'资产统计',
    
    Blocked: "挂起",
    TODO: "待处理",
    TO_DO:"待分配",
    IN_PROGRESS:"处理中",
    in_progress:"进行中",
    IN_REVIEW:"审核中",
    APPROVED:"已批准",
    NOT_APPROVED:"未批准",
    DONE:'完成',
    CLOSED:'关闭',
    performance:'性能',

    // monitor system
    hostMonitoring:'主机监控',
    host:'主机',
    alarm:'告警',
    remind:'提醒',
    ram:'内存',
    equipmentStatus:'设备状态',
    
    // monitor
    objectName:'对象名称',
    monitorType:'监控类型',
    enableMonitore:'启用监控',
    monitorMode:'监控模式',
    deviceName:'设备名称',
    deviceType:'设备类型',
    parentNode:'父节点',
    monitorDetail:'监控详情',
    basicOverview:'基础概要',
    indexList:'指标列表',
    process:'接受',
    assetDetail:'资产详情',
    addMontitor:'添加监控',
    monitorStatus:'监控状态',
    monitorEnable:'监控启用',
    runtime:'运行时间',
    disk:'磁盘',
    indexName:'指标名称',
    indexType:'指标类型',
    interval:'间隔',
    latestValue:'最新值',
    time:'时间',
    utilRate:'利用率',
    indexInfo:'指标信息',
    index:'指标',
    CPUper:'用户空间占用CPU百分比',
    uptodate:'最新',
    min:'最小',
    average:'平均',
    max:'最大',
    oneHour:'1小时',
    oneDay:'1天',
    oneWeek:'1周',
    oneMonth:'1个月',
    //
    STANDARD_EVENT:'事件',
    STANDARD_REQUEST:'请求',
    STANDARD_TROUBLESHOOT:'故障',
    ASSET_WAREHOUSE:'仓库',
    ASSET_USE_REQUEST:'索取',
    ASSET_RETURN:'利旧',
    ASSET_INSPECTION:'巡检',
    ASSET_DISCARD:'废料',
    support:'支持',
    working:'正常',
    not_working:'异常',
    markAs:'标记为',
    reporterfeedback:'评价',

    // performance
    lastWeek:'上周',
    lastMonth:'上月',
    lastYear:'去年',
    assignTicket:'已分配工单',
    solveTicket:'已解决工单',
    priorityTicket:'工单优先级',
    assignedTicket:'已分配工单',
    create:'创建',
    working:'工作中',
    not_working:'无效',
    markAs:'标记为',
    alarmContent:'报警内容',
    preview:'预览',
    assetField:'资产字段',
    inspectionIndex:'资产巡检内容',
    inspectionPoints:'巡检内容',
    assetInspection:'资产巡检',
    template:'模板',
    schedule:'巡检计划',
    maintainenceDate:'维护日期',
    inspector:'巡检员',
    abnormal:'异常',
    normal:'正常',
    addPoint:'添加点',
    ok:'确认',
    result:'巡检结果',
    frequency:'频率',
    enable:'启用',
    typeSNToSearchHardware:'键入名称以搜索硬件',
    taskCompleteWarning:'请仔细检查您的任务，完成任务后，它将被锁定且为只读状态（无法编辑）',
    finish:'完成',
    points: '指标',
    deadline: '截止时间',
    hardwareDetails: '硬件详细信息',
    allFieldsRequired: '请在所有记录的字段中填写数据',
    progress: '进度',
    reference: '参考',
    enabled: '已启用',
    disabled: '已禁用',
    inspectionReports: '检查报告',
    reports: '报告',
    kpi: '性能',
    kpiAbbr: '关键绩效指标',
    startDate: '开始日期',
    endDate: '结束日期',
    customer: '客户',
    contractNumber: '联系人号码',
    projectManager: '项目经理',
    governmentProject: '政府项目',
    itProject: '软件项目',
    milestone: '里程碑',
    issues: '问题',
    projectDetail:'项目详情',
    task:'任务',
    Classic: '列表',
    board: '看板',
    creator:'创作者',
    basicInfo:'基本信息',
    conductor:'处理人',
    creater: '创建人',
    attachments:'附件',
    predecessors:'前置任务',
    deliverable: '交付成果',
    deliveryPlan:'交付计划',
    missionDetails:'任务详细信息',
    instructions:'指示',
    ACTIVE:'活跃',
    DELETED:'已删除',
    duration:'持续时间',
    day:'天',
    tabular:'表格',
    graphical:'图形化',
    parentTask:'父任务',
    bug:'虫子',
    mainMenu:'主菜单',
    taskDetail:'任务详细信息',
    hardwareDetail:'硬件细节',
    templateDetail:'模板详细信息',
    createProject:'创建项目',
    mask:'掩码',
    purchasedOnDate:'购买于',
    mobileNumberNotFound:'找不到手机号码',
    viewHardware:'查看硬件',
    InspectionReports:'检验报告',
    InspectionReport:'检查报告',
    inspectionTask:'检查任务',
    extranetRoom: '外网机房',
    PrivateRoom: '专网机房',
    hostingRoom: '托管机房',
    assetImport: '资产导入',
    loadMore:'加载更多',
    of:'之',
    finished:'已完成',
    taskSavedMsg:'已保存任务数据',
    saveTaskTooltip:'保存任务数据供以后使用',
    workContent:'工作内容',
    workLog:'工作日志',
    checkList:'检查清单',
    similarNameWarning:'文件名应与清单中提到的相同',
    fileName:'文档名称',
    projectAssets: '项目资产',
    addSystem: '增加系统',

    taskWarning:'任务未完成，请仔细检查您的任务',
    reportUpload: '报告上传',
    inspectionCalendar: '巡检日历',
    myInspection: '我的巡检',
    exceptionInformation: '异常信息',
    exceptionReport: '异常报告',
    more: '更多',
    todayInspection: '今日巡检',
    statisticsWeek: "本周次数统计",
    inspectionsWeek: "本周巡检情况",
    abnormalWeek: "本周异常",
    weekView: '周视图',
    monthView: '月视图',
    inspectorTitle: '巡检人员',
    keyword: '请输入关键字搜索',
    allInspector: '所有巡检人',
    lastWeek: '上一周',
    nextWeek: '下一周',
    myInspection: '我的巡检',
    inspectionName: '巡检名称',
    chooseFile: '选择文件',
    filesName: '文件名',
    uploader: '上传人',
    placeInfo: '位置信息',
    projectContract: '项目合同',
    contractAmount: '合同金额',
    contractName: '合同名称',
    contractCode: '合同编号',
    projectMember: '项目成员',
    ProjectStakeholders: '项目干系人',
    customerManager: '销售经理',
    Aname:'甲方单位名称',
    projectMembers: '项目组成员',
    Workinformation: '工单信息',
    ticketInformation: '工单详情',
    workprocessed: '您的工单处理完成',
    createdprocessed: '您的工单创建完成',
    workingprocessed: '您的工单正在处理中',
    reviewprocessed: '您的工单正在审核中',
    ticketINVALID: '您的工单已作废',
    knowledge: '知识库',
    detail: '详情信息',
    sphereInfluence: '影响范围',
    resultHandling: '处理结果',
    ticketRedeploy: '工单转派',
    submitAudit: '提交审核',
    doneAndClosed: '完成并关闭',
    closetoconfirm: '关闭确认',
    closetoconfirmText: '请确认您的工单已处理完成，确认后不可退回修改',
    passTheAudit: '审核通过',
    reviewTheReturn: '审核退回',
    processRecord: '处理过程记录',
    handlingTime: '处理完成时间',
    hae: '硬件已存在',
    moreFive: '最多只能添加5条',
    taskNoEdit: '巡检计划已禁用，不能编辑!',
    parameters: '参数',
    dateWarning: '维保预警',
    outDate: '已过期',
    projectType: '项目类型',
    defaultFiles: '默认文件目录',
    folderJd: '目录权限配置',
    setManager: '设为管理者',
    delManager: '取消管理者',
    jurisdiction: '权限',
    docs: '文档目录',
    docsName: '文档目录名称',
    newuser: '新增用户',
    enterName: '请输入文件名称',
    nodel: '包含子目录不能删除',
    slectFolder: '请选择文件夹',
    defNoDel: '默认目录不能被操作',
    userRight: '用户权限',
    visibleUser: '可见用户',
    addFolder: '新增目录',
    editFolder: '编辑目录',
    documentTitle: '文档标题',
    finalVersion: '最终版本',
    markFV: '标记为最终版本',
    cancelFV: '取消最终版本',
    searchResult: '条搜索结果',
    notAddName: '名称已存在',
    notDelProject: '项目类型已被使用,不能删除',
    havaFileNotDel: '目录下有文件，不能删除',
    onlyNumber: '只能输入数字',
    maxFileUploader: '最大只能上传100M',
    alls: '所有',
    ticketPersonal: '个人空间',
    ticketRanked: '排行榜',
    haveRoleName: '角色名已存在',
    projecInfo: '项目信息',
    createUser: '创建用户',
    transfer: '转移',
    transferCompany: '公司所有者转移',
    currentOwner: '当前所有者',
    verification: '验证码不通过',
    transferring: '转移对象用户',
    ticketNum: '工单总数',
    resolutionRate: '解决率',
    wtd: '待处理工单分布',
    projectTicketStatistics: '项目工单统计',
    ticketStatistics: '工单统计',
    ticketDistribution: '工单分布',
    oneMonth: '一个月',
    threeMonth: '三个月',
    noTicket: '项目下没有工单',
    completedToday: '今日完成',
    allTicket: '所有工单',
    waitToDo: '待我处理',
    myCreate: '我创建的',
    todoTime: '处理时长',
    waitMeToDo: '我的待处理',
    myCompletionRate: '我的完成率',
    myTicketNum: '我的工单数量',
    todoTicket: '处理工单总数',
    closeTickets: '工单完成数',
    creatTickets: '创建工单完成数',
    notCloseTicket: '未关闭工单',
    avgTime: '平均处理时长',
    cumulativeTime: '累计处理时长',
    myTicketDis: '我的工单分布',
    personTicketRanked: '个人排行榜',
    rankings: '排名',
    closeT: '完成数',
    completionRate: '完成率',
    projectRanked: '项目排行榜',
    entrants: '上榜者',
    ontheproject: '上榜项目',
    toproject: '所属项目',
    tuimc: '用户存在多家公司',
    tdlt3d: '30天内不能转移',
    userOwnerTip: '确定要将该公司所有者转移到用户John，本次转移后30天内无法再次转移公司所有者',
    editNewPassword: '请输入你的新密码',
    newPassword: '新密码',
    hardwareTrend: '资产增长',
    softwareTrend: '软件增长',
    count: '硬件资产',
    switchs: '交换机',
    harsoftware: '软件资产',
    overInsurance: '已过保',
    soonInsurance: '即将过保',
    assetStates: '资产状态分布',
    projectAssetstus: '项目资产概况',
    zoneAssetstus: '区域资产概况',
    assetexpired: '资产过保概况',
    directoryDescription: '目录说明',
    ticketObsolete: '工单作废',
    INVALID: '已作废',
    isInvalidTicket: '是否作废该工单',
    toticketDetails: '工单已作废，是否跳转到工单详情页'
  }
}

